import IconButton from '@material-ui/core/IconButton'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import consts from '../../../util/consts'
import Paginate from '../../components/Pagination'
import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../components/hooks/BaseTableComponents'
import Icon from '@mdi/react'
import { mdiNoteEditOutline, mdiDeleteOutline, mdiDelete } from '@mdi/js'
import { useQueryParams } from '../../../util/utils'
import { usePermissions } from '../../../hooks/usePermission'
import { useHistory, useLocation } from 'react-router-dom'
import { deleteClient } from '../ClientActions'
import BasePopUp from '../../../components/hooks/BasePopUp'

function List(props) {
  const items = useSelector(state => state.client.items)
  const page = useSelector(state => state.client.page)
  const totalSize = useSelector(state => state.client.totalSize)
  const sizePerPage = useSelector(state => state.client.sizePerPage)

  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  const filters = useQueryParams(location?.search)

  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canUpdate, canDelete } = usePermissions()

  const { classes } = props

  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [clientToDelete, setClientToDelete] = useState(null)

  const handleSubmit = data => {
    const searchParams = new URLSearchParams(data || filters)
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const onMovePage = (event, newPage) => {
    const data = { ...filters, page: newPage + 1 }
    handleSubmit(data)
  }

  const handleChangeRowsPerPage = event => {
    const data = { ...filters, rows: event.target.value, page: 1 }
    handleSubmit(data)
  }

  const handleOpenDeleteModal = (id = null) => {
    if (id) {
      setClientToDelete(id)
    }
    setOpenDeleteModal(!openDeleteModal)
  }

  const handleConfirmDelete = () => {
    if (clientToDelete) {
      dispatch(deleteClient(clientToDelete))
      setOpenDeleteModal(false)
      setClientToDelete(null)
    }
  }

  return (
    <>
      <TableContainer className={classes.tableStickHeader}>
        <Table stickyHeader size="medium" className={classes.table}>
          <TableHead>
            <TableRow>
              <StyledTableCellHeader>Cliente</StyledTableCellHeader>
              <StyledTableCellHeader>Telefone</StyledTableCellHeader>
              <StyledTableCellHeader>Bairro</StyledTableCellHeader>
              <StyledTableCellHeader>Email</StyledTableCellHeader>
              <StyledTableCellHeader>Aniversário</StyledTableCellHeader>
              <StyledTableCellHeader>Ações</StyledTableCellHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map(item => (
              <TableRow key={item.id}>
                <StyledTableCellBody>{item.name}</StyledTableCellBody>
                <StyledTableCellBody>{item.phone}</StyledTableCellBody>
                <StyledTableCellBody>{item.neighborhood}</StyledTableCellBody>
                <StyledTableCellBody>{item.email}</StyledTableCellBody>
                <StyledTableCellBody>{item.birthdate}</StyledTableCellBody>
                <StyledTableCellBody>
                  {canUpdate('clientes', permissionUser) && (
                    <IconButton component={Link} to={`/clients/${item.id}/edit`}>
                      <Icon path={mdiNoteEditOutline} size={1} />
                    </IconButton>
                  )}
                  {canDelete('clientes', permissionUser) && (
                    <IconButton onClick={() => handleOpenDeleteModal(item.id)}>
                      <Icon path={mdiDelete} size={1} />
                    </IconButton>
                  )}
                </StyledTableCellBody>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Paginate
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPage={sizePerPage}
        rows={totalSize}
        page={page - 1}
        handleChangePage={onMovePage}
      />

      <BasePopUp
        open={openDeleteModal}
        type="error"
        title="Excluir Cliente"
        message="Deseja realmente excluir este cliente?"
        handleOpen={handleOpenDeleteModal}
        onConfirm={handleConfirmDelete}
      />
    </>
  )
}

export default List
